/* Correct cached homepage campaigns against absolute UK dates; no network calls. */
(() => {
  'use strict';
  const schedule = window.ByardsHomeSeason;
  const root = document.querySelector('#main-content.bh-home');
  if (!schedule || !root) return;
  let timer;

  function restoreFocus(content, previous) {
    if (!previous) return;
    const candidates = Array.from(content.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'));
    const replacement = candidates.find(item => previous.id && item.id === previous.id)
      || candidates.find(item => previous.href && item.getAttribute('href') === previous.href)
      || candidates.find(item => !item.disabled && item.tabIndex >= 0);
    if (replacement) replacement.focus({ preventScroll: true });
  }

  function apply(scope = root) {
    const stage = schedule.resolve();
    const previousStage = Number(document.documentElement.dataset.bhSeasonStage);
    document.documentElement.dataset.bhSeasonStage = String(stage);
    let changed = previousStage !== stage;
    const slots = Array.from(scope.querySelectorAll('[data-bh-season-switch]'));
    if (scope.matches && scope.matches('[data-bh-season-switch]')) slots.unshift(scope);
    for (const slot of slots) {
      // Outer slots can replace inner slots from the original query snapshot.
      if (!slot.isConnected) continue;
      const threshold = Number(slot.dataset.bhSeasonThreshold);
      const active = stage >= threshold ? 'after' : 'before';
      const content = Array.from(slot.children).find(child => child.hasAttribute('data-bh-season-content'));
      const source = Array.from(slot.children).find(child => child.tagName === 'TEMPLATE' && child.dataset.bhSeasonTemplate === active);
      if (!content || !source || slot.dataset.bhSeasonActive === active) continue;
      const focused = content.contains(document.activeElement) ? {
        id: document.activeElement.id,
        href: document.activeElement.getAttribute('href')
      } : null;
      content.replaceChildren(source.content.cloneNode(true));
      slot.dataset.bhSeasonActive = active;
      slots.push(...content.querySelectorAll('[data-bh-season-switch]'));
      restoreFocus(content, focused);
      changed = true;
    }
    if (changed) document.dispatchEvent(new CustomEvent('bh:season:change', { detail: { stage, scope } }));
  }

  function queueTransition() {
    window.clearTimeout(timer);
    if (schedule.mode !== 'auto') return;
    const now = Date.now();
    const next = schedule.transitions.find(time => time > now);
    if (next) timer = window.setTimeout(refresh, Math.min(next - now + 100, 86400000));
  }
  function refresh() { apply(); queueTransition(); }

  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('shopify:section:load', event => apply(event.target));
  refresh();
})();
